export default "__VITE_ASSET__09983f4c__"